import { FieldArray, useField } from 'formik';
import { useTranslation } from 'react-i18next';
import FormFields from '../../../../themes/admin/Fields/FormFields';
import { VehicleColumn } from '../shared';

const EquipmentField = ({ formPrefix, index }: { formPrefix: string; index: number }) => {
    const { t } = useTranslation('finderVehicle');

    return (
        <>
            <VehicleColumn>
                <FormFields.InputField
                    label={t('finderVehicle:fields.listing.vehicleEquipmentCode.label', { index })}
                    name={`${formPrefix}.code`}
                    disabled
                />
            </VehicleColumn>
            <VehicleColumn>
                <FormFields.InputField
                    label={t('finderVehicle:fields.listing.vehicleEquipmentNameLocalize.label', { index })}
                    name={`${formPrefix}.name.localize`}
                    disabled
                />
            </VehicleColumn>
            <VehicleColumn>
                <FormFields.InputField
                    label={t('finderVehicle:fields.listing.vehicleEquipmentDescriptionLocalize.label', { index })}
                    name={`${formPrefix}.description.localize`}
                    disabled
                />
            </VehicleColumn>
        </>
    );
};

const EquipmentSection = () => {
    const [field, meta] = useField({ name: 'listing.vehicle.equipment' });
    const { value } = meta;

    return (
        <FieldArray
            name="listing.vehicle.equipment"
            render={() => {
                if (!value || value.length === 0) {
                    return null;
                }

                return value.map((key: string, index: number) => (
                    <EquipmentField formPrefix={`listing.vehicle.equipment.${index.toString()}`} index={index} />
                ));
            }}
        />
    );
};

export default EquipmentSection;
